<template>
  <span></span>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Notification',
  methods: {
    openNotificationWithIcon(type) {
      this.$notification.config({
        placement: 'bottomLeft',
      });

      this.$notification[type]({
        message: this.message,
        description: this.description,
      });
    },
  },
  computed: {
    ...mapState('notification', ['type', 'message', 'description', 'timestamp']),
  },
  watch: {
    timestamp: function () {
      this.openNotificationWithIcon(this.type)
    }
  },
}
</script>

<style lang='stylus'>

</style>